
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class YxxTable extends Vue {
    //鱼虾蟹
    table = {
        data: [],
        column: [
            {
                key: 'baozi',
                title: '下注全围',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.baozi) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.baozi.bet)
                    }
                    return h('span', str)
                }
            },
            {
                key: 'one',
                title: '下注单骰',
                align: 'center',
                render: (h, params) => {
                    let str = ''
                    let arr = []
                    let obj = JSON.parse(params.row.opt_detail).hits.hits
                    if (obj) {
                        for (const key in obj) {
                            if (key.includes('one')) {
                                str += '<p>' + this.getType(key) + "<span style='color:red;'>" + (this as any).getMoney(obj[key].bet) + '</span>' + '</p>'
                            }
                        }
                    }
                    return h('div', {
                        style: {
                            marginTop: '5px'
                        },
                        domProps: {
                            innerHTML: str
                        }
                    })
                }
            },
            {
                key: 'two',
                title: '下注组合',
                align: 'center',
                render: (h, params) => {
                    let str = ''
                    let arr = []
                    let obj = JSON.parse(params.row.opt_detail).hits.hits
                    if (obj) {
                        for (const key in obj) {
                            if (key.includes('two')) {
                                str += '<p>' + this.getType(key) + "<span style='color:red;'>" + (this as any).getMoney(obj[key].bet) + '</span>' + '</p>'
                            }
                        }
                    }
                    return h('div', {
                        style: {
                            marginTop: '5px'
                        },
                        domProps: {
                            innerHTML: str
                        }
                    })
                }
            },
            {
                key: 'black',
                title: '开奖',
                align: 'center',
                width: 150,
                render: (h, params) => {
                    let str = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        str = JSON.parse(params.row.opt_detail).award_content.point.poker
                    }
                    return h('div', {
                        style: {
                            marginTop: '5PX'
                        },
                        domProps: {
                            innerHTML: str.map((x) => {
                                return "<img style='width:35px;' src=img/gameImg/yxx/" + x + '.png>'
                            })
                        }
                    })
                }
            },
            {
                key: 'black',
                title: '总投注',
                align: 'center',
                render: (h, params) => {
                    let str = 0
                    let arr = JSON.parse(params.row.opt_detail).hits.hits
                    for (const key in arr) {
                        str += (this as any).getMoney(arr[key].bet, 1)
                    }
                    return h('span', str.toFixed(2))
                }
            },
            {
                key: 'chang_point',
                title: '总返奖',
                align: 'center',
                render: (h, params) => {
                    let str = (this as any).getMoney(params.row.chang_point)
                    let color = '#333'
                    if (str > 0) {
                        color = 'red'
                    } else if (str < 0) {
                        color = 'blue'
                    }
                    return h(
                        'span',
                        {
                            style: {
                                color: color
                            }
                        },
                        str
                    )
                }
            }
        ]
    }
    //鱼虾蟹
    getType(type) {
        let arr: any = [
            { key: 'one_1', name: '鱼：' },
            { key: 'one_2', name: '虾：' },
            { key: 'one_3', name: '葫芦：' },
            { key: 'one_4', name: '铜钱：' },
            { key: 'one_5', name: '蟹：' },
            { key: 'one_6', name: '鸡：' },
            { key: 'two_1_2', name: '组合（鱼-虾）：' },
            { key: 'two_1_3', name: '组合（鱼-葫芦）：' },
            { key: 'two_1_4', name: '组合（鱼-铜钱）：' },
            { key: 'two_1_5', name: '组合（鱼-蟹）：' },
            { key: 'two_1_6', name: '组合（鱼-鸡）：' },
            { key: 'two_2_3', name: '组合（虾-葫芦）：' },
            { key: 'two_2_4', name: '组合（虾-铜钱）：' },
            { key: 'two_2_5', name: '组合（虾-蟹）：' },
            { key: 'two_2_6', name: '组合（虾-鸡）：' },
            { key: 'two_3_4', name: '组合（葫芦-铜钱）：' },
            { key: 'two_3_5', name: '组合（葫芦-蟹）：' },
            { key: 'two_3_6', name: '组合（葫芦-鸡）：' },
            { key: 'two_4_5', name: '组合（铜钱-蟹）：' },
            { key: 'two_4_6', name: '组合（铜钱-鸡）：' },
            { key: 'two_5_6', name: '组合（蟹-鸡）：' }
        ]
        return arr.find((el) => el.key == type).name || ''
    }

    @Prop()
    listdata
}
